<script>
	import InfoIcon from 'components/svg/info-icon.vue';
	import CheckboxIcon from 'components/svg/checkbox-icon.vue';

	export default {
		props: {
			type: {
				type: String,
				default: 'info'
			},
			level: {
				type: String,
				default: 'status'
			}
		},
		components: {
			'info-icon': InfoIcon,
			'checkbox-icon': CheckboxIcon
		},
		computed: {
			icon() {
				const iconMap = {
					warning: 'fa-solid fa-triangle-exclamation',
					error: 'fa-solid fa-circle-exclamation'
				};

				return iconMap[this.type];
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.message {
		--message-accent-color: #{$c-blue};
		display: flex;
		align-items: baseline;
		margin: 1rem 0;
		padding: 0.75rem 0.5rem;
		font-size: 1rem;
		border: 1px solid var(--message-accent-color);
		border-left-width: 6px;
		border-radius: 4px;
		background-color: $c-grey-extra-light;
		color: $c-slate-dark;

		&.success {
			--message-accent-color: #{$c-green};
		}

		&.warning {
			--message-accent-color: #{$c-warning};
		}

		&.error {
			--message-accent-color: #{$c-red};
		}

		.icon-container {
			margin-right: 0.5rem;
			color: var(--message-accent-color);

			svg {
				width: 1rem;
				stroke: currentColor;
				fill: currentColor;
			}
		}
	}
</style>
<template>
	<div
		class="message"
		:class="type"
		:role="level">
		<div class="icon-container">
			<i
				v-if="icon"
				:class="icon"></i>
			<checkbox-icon v-else-if="type === 'success'"></checkbox-icon>
			<info-icon v-else></info-icon>
		</div>
		<div class="message-content">
			<slot></slot>
		</div>
	</div>
</template>
